
export const parseScheduleMonthToModel = (response) => ({
    ...response
});